import React from "react";

import cn from "classnames";

import { boxForwardRef } from "../../../../../helpers/common/Box/Box";
import { Content } from "../../../../Content";
import { createDisplayNameForButtonCellActionElement } from "../../utils/getDisplayName";
import { createTestIdForButtonCellActionElement } from "../../utils/getTestId";

import type { BoxComponentWithDefault } from "../../../../../helpers/common/Box/Box";
import type { ContentTextProps } from "../../../../Content/Content/components/Text/ContentText";
import type { ButtonCelleActionView } from "../../types";

import classes from "./ButtonCellActionLabel.styl";

type ButtonCellActionLabelProps = Omit<
    ContentTextProps,
    | "view"
    | "textCase"
    | "underline"
    | "strikethrough"
    | "alignmentX"
    | "maxLines"
    | "truncateStyle"
    | "width"
    | "asList"
    | "quote"
    | "italic"
>;
type ButtonCellActionLabelWithParentView = ButtonCellActionLabelProps & {
    parentView?: ButtonCelleActionView;
};
const LABEL_TEST_ID = createTestIdForButtonCellActionElement("label");

export const ButtonCellActionLabel = boxForwardRef<
    BoxComponentWithDefault<"span", ButtonCellActionLabelProps, "className">
>((props, ref) => {
    const {
        children,
        size = "17",
        parentView,
        ...restProps
    } = props as ButtonCellActionLabelWithParentView;

    const customColors = cn(
        classes["label"],
        classes[`__view-${parentView || "primary"}`],
    );

    return children ? (
        <Content.Text
            {...restProps}
            size={size}
            data-tsid={LABEL_TEST_ID}
            view="custom"
            customColorsStyles={customColors}
            ref={ref}
        >
            {children}
        </Content.Text>
    ) : null;
});

ButtonCellActionLabel.displayName =
    createDisplayNameForButtonCellActionElement("Label");

export default ButtonCellActionLabel;
